import React,{ useState } from "react";
import { AppInputFieldSelect } from "../../../../../widget/styledComponents/input_field.style";

export const PickPropertyType = ({ onSelect }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const options =[
        "Bungalow",
        "Duplex",
        "Triplex",
        "Terrace_House",
        "Detached_House",
        "Semi_Detached_House",
        "Mansion",
        "Apartment",
        "Flat_in_a_block",
        "Cottage",
        "Office",
        "Hotel",
        "Guest_house",
        "Restaurant",
        "Warehouse",
        "Factory",
        "Educational_center",
        "Religious_building",
        "Health_facility",
        "Recreational_center",
        "Mall",
        "Shop",
        "Farming",
        "Government_building",
        "Other"
    ];
    const handleSelect = (event) => {
      const selectedValue = event.target.value;
      setSelectedOption(selectedValue);
      console.log("Selected value:", selectedValue);
      onSelect(selectedValue)
    };
      return (
        <div>
            <AppInputFieldSelect
                className="browser-default" required
                 value={selectedOption} onChange={handleSelect}
                >
                <option value="" disabled selected>Choose your option</option>
                {options.map((option) => (
                <option key={option}  value={option}
                >
                    {option.replace(/_/g, " ")}
                </option >
                ))}
            </AppInputFieldSelect>
        </div>
      )
    }